import SangjoPageLayout from "@/components/DefaultPageLayout";
import Chip from "@/components/Chip";
import { colors } from "goi_common";
import { DefaultPageContainer } from "@/components/container";
import CustomerReview from "@/containers/SangjoGoiContainer/components/CustomerReview";
import FuneralGuidebook from "@/containers/SangjoGoiContainer/components/FuneralGuidebook";
import ServiceIntroduction from "@/containers/SangjoGoiContainer/components/ServiceIntroduction";
import { GetStaticProps } from "next";

export const getStaticProps: GetStaticProps = async ({ params }) => {
  const description =
    "고이 장례 연구소의 상조 서비스 비용과 후기를 안내드립니다. 다른 상조와 고이를 비교해보시고, 상조 서비스에 들어가는 자세한 비용을 알아보세요.";
  return {
    props: {
      pageDescription: description,
      pageKeywords:
        "상조, 상조비교, 선불제상조, 후불제상조, 프리드라이프, 보람상조, 대명아임레디, 고이, 고이상조, 고이장례, 고이장례연구소, 헤이상조, 가전결합상품, 결합상품",
      pageOgTitle: `장례의 모든 것, 고이 상조 비용 및 정보 안내 - [상조 상품 비교 사이트, 헤이상조]`,
      pageOgDescription: description,
      pageOgImage: "",
    },
  };
};

const GoiSangjoDetail = () => {
  return (
    <SangjoPageLayout
      title="장례의 모든 것, 고이"
      chip={<Chip label="광고(Ad)" color={colors.gray500} />}
    >
      <ServiceIntroduction />
      <FuneralGuidebook />
      <CustomerReview />
    </SangjoPageLayout>
  );
};

export default GoiSangjoDetail;
